import { useCallback, useMemo, useState } from "react";

// UI Layer hook para el estado del modal
function useListMessageUI() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);
  const toggleModal = useCallback(() => setIsOpen((prev) => !prev), []);
  return useMemo(() => ({ isOpen, openModal, closeModal, toggleModal }), [isOpen, openModal, closeModal, toggleModal]);
}

export default useListMessageUI;